import React from "react";
import NavBar from "./Navbar/NavBar";

const Award = () => {
  return (
    <div className="grid grid-flow-row">
      <NavBar />
      <div className="mt-24"> Award</div>
    </div>
  );
};

export default Award;
